import type { BoardCard } from '@nightshift/ui-types';
import { cardMenuItems, type CardMenuItem, type CardMenuOptions } from './board-actions.ts';

export interface BoardSelection {
  keys: readonly string[];
  anchor: string | null;
}

export function selectBoardCard(
  selection: BoardSelection,
  key: string,
  stack: readonly string[],
  modifiers: { ctrlKey: boolean; metaKey: boolean; shiftKey: boolean },
): BoardSelection {
  const anchor = selection.anchor === null ? -1 : stack.indexOf(selection.anchor);
  const end = stack.indexOf(key);
  if (modifiers.shiftKey && anchor >= 0 && end >= 0) {
    return { anchor: selection.anchor, keys: stack.slice(Math.min(anchor, end), Math.max(anchor, end) + 1) };
  }
  if (modifiers.ctrlKey || modifiers.metaKey) {
    return {
      anchor: key,
      keys: selection.keys.includes(key) ? selection.keys.filter((entry) => entry !== key) : [...selection.keys, key],
    };
  }
  return { anchor: key, keys: [key] };
}

/** Intersect commands, retaining each ticket's own queue target when executed. */
export function groupMenuItems(cards: readonly BoardCard[], options: CardMenuOptions): CardMenuItem[] {
  const menus = cards.map((card) => cardMenuItems(card.state, { ...options, deployable: card.deployable, dependsOn: card.dependsOn }));
  return (menus[0] ?? []).filter((item) => menus.every((menu) => menu.some((other) => other.action === item.action)))
    .map((item) => item.action === 'queue' && cards.length > 1
      ? { ...item, label: 'Queue behind dependencies', hint: 'Each ticket waits for its own blockers.' }
      : item);
}
